/* eslint-disable no-console */
import { of } from 'rxjs/observable/of';
import { empty } from 'rxjs/observable/empty';
import { type ActionsObservable } from 'redux-observable';
import get from 'lodash/get';

import { fetchFailed, fetchSuccess } from '../../common/fetch-request-analytics';
import { CHECK_CONFLUENCE_USER_PERMISSIONS, updateConfluenceUserAccess } from '../actions';
import { FORBIDDEN, OK } from '../confluence/user/types';

import { fetchConfluenceCurrentUser } from './requests';
import { type MiddlewareAPI } from 'redux';
import { type State } from '../types';
import { getProjectId, getProjectType } from '../project/selectors';

export default (action$: ActionsObservable<any>, store: MiddlewareAPI<State>) => {
	return action$.ofType(CHECK_CONFLUENCE_USER_PERMISSIONS).switchMap(() => {
		return fetchConfluenceCurrentUser(
			getProjectId(store.getState()),
			getProjectType(store.getState()),
		)
			.mergeMap((value) => {
				fetchSuccess('confluence.user');

				if (get(value, 'operations.length')) {
					return of(updateConfluenceUserAccess(OK));
				}

				return of(updateConfluenceUserAccess(FORBIDDEN));
			})
			.catch((err) => {
				if (err.statusCode === 403) {
					return of(updateConfluenceUserAccess(FORBIDDEN));
				}

				fetchFailed('confluence.user', err);
				return empty();
			});
	});
};
